export default function humanizedDateFilter($filter) {
  'ngInject';

  function isToday(date) {
    return ((new Date).toDateString() === date.toDateString());
  }

  return function(dateString) {
    const HOUR = 60 * 60 * 1000;
    const date = new Date(dateString);

    const current = new Date;
    const agoFormatLimit = 8 * HOUR; // 8 hours
    const isTodayFormat = current.toDateString() === date.toDateString();

    const isAgoFormat = date > (current - agoFormatLimit);

    if (true) {

    }

    // TODO refactor with object {today: limit, now: limit etc}
    if (isAgoFormat) {
      const differenceInHours = (current - date) / HOUR;
      if (differenceInHours > 1.5) {
        return `${Math.round(differenceInHours)} hours ago`;
      } else if (differenceInHours > 0.05) {
        return 'less than an hour ago';
      } else {
        return 'now';
      }
    } else if (isTodayFormat) {
      return 'today';
    }

    return $filter('date')(date, 'MMM, d');
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/engineer/util/humanized-date.filter.js